export default __webpack_public_path__ + "static/media/swiftype.7b8cc8f7.svg";